import React, { useEffect, useImperativeHandle, useState } from 'react'
import { dataLayerGA } from 'utils/dataLayerHelper.js'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'utils/globalNav/unifiedLogin'
import { isEmpty, resolveKeysInObjectsArrays, checkHiFiveFlow } from 'utils/browserHelper'
import { sendOtpForSignIn } from 'api/flights/results'
import USER_PROFILE_PAGE_CONTANTS from '../../components/GlobalNav/UserProfile/UserProfileConstants'
import { errorConfig } from '../../components/GlobalNav/UserProfile/screens/errorConfig'
import { Button } from '@cleartrip/bento'
import Clevertap from 'analytics'

const GetOtpButton = React.forwardRef((props, ref) => {
    const [loading, setLoading] = useState(false)
    const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])

    const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
    const pathname = query.split('/')
    const pagePath = pathname[2]
    const isHiFiveFlow = checkHiFiveFlow(pathname)

    const getOtpValue = () => {
        const otp = otpDigits.join('')
        return otp
    }
    useImperativeHandle(ref, () => ({
        fire() {
            getOtp()
        }
    }))

    useEffect(()=>{
        if(props?.mobile?.length === 10 && props?.validateMobileHandler() && !props?.isInline){
            getOtp()
        }
    }, [props?.mobile])

    useEffect(()=>{
        if(props?.isInline) {
            ClevertapEvent({
                actionName: 'details_otp_button_pop_up',
                source_page_name: 'flights_itinerary', 
                platform: 'desktop',
                is_logged_in: 'no',
                domainName: 'www.cleartrip.com',
                login_cookie: props?.abInline
            })
        }
    },[])

    const disabled = getOtpValue().length != 6

    const getOtp = async () => {
        if (props?.isInline) {
            if(props?.abInline === 'a' || props?.abInline === 'b') {
                ClevertapEvent({
                    actionName: 'details_get_otp_clicked',
                    actionType: 'Button',
                    source_page_name: 'flights_itinerary',
                    platform: 'desktop',
                    is_logged_in: 'no',
                    action: 'signin',
                    login_cookie: props?.abInline,
                    domainName: 'www.cleartrip.com'
                })
            }

        }
        dataLayerGA({ section: 'Login' }, 'login_otp_clicked')

        props?.setApiError('')
        let mobileValid = props?.validateMobileHandler()
        if (!props?.isInline) {
            ClevertapEvent({
                actionName: 'Get_OTP_entered_on_login modal',
                actionType: 'Button',
                page:
                    pagePath === 'results'
                        ? 'SRP'
                        : isEmpty(pagePath) || isHiFiveFlow
                        ? 'HP'
                        : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                        ? 'Itinerary'
                        : 'Confirmation_Page',

                currentPage: pagePath
            })
        }
        try {
            if (mobileValid) {
                 if (props?.isInline) {
                props?.setInlineLogin(true)
                props?.setGetOtpClicked(true)
                }
                setLoading(true)
                if (!props?.isInline) {
                    ClevertapEvent({
                        actionName: 'Mobile_number_entered_on_login_modal',
                        actionType: 'Button',
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath
                    })
                }
                const payload = {
                    type: 'MOBILE',
                    value: props?.mobile,
                    countryCode: props?.countryCode,
                    action: 'SIGNIN'
                }
                const response = await sendOtpForSignIn(payload)
                const { status, data, error } = response || {}
                if (status === 202) {
                    const { action } = data || {}
                    props?.setPageName(USER_PROFILE_PAGE_CONTANTS.VERIFY_MOBILE_NUMBER)
                    if (props?.superCoinLogin) {
                        Clevertap.event('Air_UI_Action', {
                            action_name: 'Loging in using supercoins toggle',
                            action_value: 'Entered phone number'
                        })
                    }
                } else {
                    const { response = { data: {} } } = error || {}
                    const { data = {} } = response
                    const { message } = data
                    const errRes = errorConfig[message] || errorConfig.default
                    ClevertapEvent({
                        actionName: 'Error_Occured_Login_modal',
                        actionType: 'Button',
                        page:
                            pagePath === 'results'
                                ? 'SRP'
                                : isEmpty(pagePath) || isHiFiveFlow
                                ? 'HP'
                                : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                                ? 'Itinerary'
                                : 'Confirmation_Page',

                        currentPage: pagePath,
                        error_type:
                            message === 'OTP_SEND_LIMIT_EXCEEDED' ? 'OTP limit exceeded' : 'OTP generation failed'
                    })
                    props?.setApiError(errRes)
                }
                setLoading(false)
            } else {
                ClevertapEvent({
                    actionName: 'Invalid_value_entered',
                    actionType: 'Button',
                    page:
                        pagePath === 'results'
                            ? 'SRP'
                            : isEmpty(pagePath) || isHiFiveFlow
                            ? 'HP'
                            : pathname.length > 4 && pathname[4] === 'info' && pathname[2] === 'itinerary'
                            ? 'Itinerary'
                            : 'Confirmation_Page',

                    currentPage: pagePath,
                    field_name: 'mobile',
                    form_name: 'LoginSignUp'
                })
            }
        } catch (e) {
            console.log('otp api error', e)
        }
    }

    return (
        <>
            {props?.isInline ? (
                <div>
                <Button
                    style={{ width: '81px', height: '28px' }}
                    className={` flex h-7 bg-black-500 hover:bg-black-500 flex-middle br-6`}
                    onClick={() => getOtp()}
                >
                    <span className={`fs-2 fw-600 lh-title flex flex-middle`}>{'Get OTP'}</span>
                </Button>
                
            </div>
            ) : (
                <div>
                    <Button
                        className={`h-10  ${props?.abLogin === 'a' ? 'bg-black-500 hover:bg-black-500':''}`}
                        disabled={!disabled}
                        size="md"
                        type="secondary"
                        busy={loading}
                        full
                        onClick={() => getOtp()}
                    >
                        <span className={`${!disabled ? 'c-grey-30' : ''} fs-3 fw-500`}>{'Get OTP'}</span>
                    </Button>
                </div>
            )}
        </>
    )
})

export default GetOtpButton
